import React from 'react';
import { useTranslation } from 'react-i18next';
import { Smartphone, Zap, Monitor, Gauge } from 'lucide-react';

const MobileGaming = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: Smartphone,
      title: t('mobile.features.anywhere.title'),
      description: t('mobile.features.anywhere.description')
    },
    {
      icon: Zap,
      title: t('mobile.features.instant.title'),
      description: t('mobile.features.instant.description')
    },
    {
      icon: Monitor,
      title: t('mobile.features.crossPlatform.title'),
      description: t('mobile.features.crossPlatform.description')
    },
    {
      icon: Gauge,
      title: t('mobile.features.performance.title'),
      description: t('mobile.features.performance.description')
    }
  ];

  return (
    <section className="py-20 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Content */}
          <div>
            <h2 className="font-display text-3xl md:text-5xl font-bold mb-6">
              <span className="gaming-gradient-text">{t('mobile.title')}</span>
            </h2>
            <p className="text-lg text-white/60 mb-10">
              {t('mobile.subtitle')}
            </p>

            <div className="grid sm:grid-cols-2 gap-6">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-4">
                  <div className="w-12 h-12 shrink-0 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center">
                    <feature.icon className="w-6 h-6 text-red-500" />
                  </div>
                  <div>
                    <h3 className="font-semibold mb-1">{feature.title}</h3>
                    <p className="text-sm text-white/50">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right side - Visual */}
          <div className="relative">
            <div className="absolute inset-0 gaming-gradient rounded-3xl blur-[60px] opacity-30" />
            <div className="relative gradient-border rounded-3xl p-1">
              <div className="bg-gradient-to-br from-white/10 to-white/5 rounded-3xl p-8 md:p-12">
                {/* Phone mockup */}
                <div className="relative mx-auto w-48 md:w-64">
                  <div className="bg-black rounded-[2rem] p-2 border-4 border-gray-800">
                    <div className="bg-gradient-to-br from-red-500/20 via-purple-500/20 to-blue-500/20 rounded-[1.5rem] aspect-[9/16] flex items-center justify-center">
                      <div className="text-center">
                        <div className="w-16 h-16 mx-auto mb-4 rounded-2xl gaming-gradient flex items-center justify-center animate-pulse-glow">
                          <Smartphone className="w-8 h-8 text-white" />
                        </div>
                        <p className="font-display text-sm font-bold">Dawn Of Battles</p>
                        <p className="text-xs text-white/50 mt-1">Mobile Gaming</p>
                      </div>
                    </div>
                  </div>
                  {/* Notch */}
                  <div className="absolute top-4 left-1/2 -translate-x-1/2 w-20 h-6 bg-black rounded-full" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileGaming;
